import React from "react";
// Components
import { PopUpBackground } from "./styles";

const Popup = ({ children, isShowed, setIsShowed }) => {
  const handleHidePopupAcrossBackground = (e) => {
    if (e.target.id === "popUpBackground") {
      setIsShowed(false);
    }
  };

  return (
    <PopUpBackground onClick={handleHidePopupAcrossBackground} id="popUpBackground" isShowed={isShowed}>
      {children}
    </PopUpBackground>
  );
};

export default Popup;
